import { LandingPageBase } from '../landing-page-base/landing-page-base.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-guid-expired',
    templateUrl: './guid-expired.component.html',
    styleUrls: ['./guid-expired.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule, LandingPageBase]
})
export class GuidExpired {
    headerText: string = 'Link Expired';
    contentText: string = 'Your link has expired. To request a new link contact the Minster Law team on {{TEMP_TO_REPLACE_WITH_CONTACT}}';

    constructor() {
    }

    ngOnInit(): void {
    }
}
